import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ServiceRequirement} from './service-requirement.model';

export const loadServiceRequirements = createAction(
  '[ServiceRequirement/API] Load ServiceRequirements',
  props<{ serviceRequirements: ServiceRequirement[] }>()
);

export const addServiceRequirement = createAction(
  '[ServiceRequirement/API] Add ServiceRequirement',
  props<{ serviceRequirement: ServiceRequirement }>()
);

export const upsertServiceRequirement = createAction(
  '[ServiceRequirement/API] Upsert ServiceRequirement',
  props<{ serviceRequirement: ServiceRequirement }>()
);

export const addServiceRequirements = createAction(
  '[ServiceRequirement/API] Add ServiceRequirements',
  props<{ serviceRequirements: ServiceRequirement[] }>()
);

export const upsertServiceRequirements = createAction(
  '[ServiceRequirement/API] Upsert ServiceRequirements',
  props<{ serviceRequirements: ServiceRequirement[] }>()
);

export const updateServiceRequirement = createAction(
  '[ServiceRequirement/API] Update ServiceRequirement',
  props<{ serviceRequirement: Update<ServiceRequirement> }>()
);

export const updateServiceRequirements = createAction(
  '[ServiceRequirement/API] Update ServiceRequirements',
  props<{ serviceRequirements: Update<ServiceRequirement>[] }>()
);

export const deleteServiceRequirement = createAction(
  '[ServiceRequirement/API] Delete ServiceRequirement',
  props<{ id: string }>()
);

export const deleteServiceRequirements = createAction(
  '[ServiceRequirement/API] Delete ServiceRequirements',
  props<{ ids: string[] }>()
);

export const clearServiceRequirements = createAction(
  '[ServiceRequirement/API] Clear ServiceRequirements'
);

//  CUSTOM ACTIONS
export const createServiceRequirementMutation = createAction(
  '[ServiceRequirement/API] Create ServiceRequirements',
  props<{ input: any }>()
);

export const updateServiceRequirementMutation = createAction(
  '[ServiceRequirement/API] Edit ServiceRequirement',
  props<{ input: any }>()
);

export const getServiceRequirements = createAction(
  '[ServiceRequirement/API] Get ServiceRequirements',
  props<{ groupUniqueId: string }>()
);

export const deleteServiceRequirementMutation = createAction(
  '[ServiceRequirement/API] Remove ServiceRequirements',
  props<{ requirementUniqueId: string, id: string  }>()
);
